import { MutationTree } from "vuex"
import type { State } from "./state"

export enum MutationType {
    SET_MANUALLY_SELECTED = "SET_MANUALLY_SELECTED",
    SET_SELECTED_DATA_REGION = "SET_SELECTED_DATA_REGION",
    SET_DEFAULT_REGION = "SET_DEFAULT_REGION",
}

export type Mutations = {
    [MutationType.SET_MANUALLY_SELECTED](state: State, value: boolean): void
    [MutationType.SET_SELECTED_DATA_REGION](state: State, value: string): void
    [MutationType.SET_DEFAULT_REGION](state: State, value: string): void
}

export const mutations: MutationTree<State> & Mutations = {
    [MutationType.SET_MANUALLY_SELECTED](state, value) {
        state.isManuallySelected = value
    },
    [MutationType.SET_SELECTED_DATA_REGION](state, value) {
        // Store the selected data region in localStorage
        localStorage.setItem("data_region", value)
        state.selectedDataRegion = value
    },
    [MutationType.SET_DEFAULT_REGION](state, value) {
        state.defaultRegion = value
    },
}
